export function createMemoryTokenStore(initial = null) {
    let tokens = initial;
    return {
        read: () => tokens,
        write: (next) => {
            tokens = next;
        },
        clear: () => {
            tokens = null;
        },
    };
}
/**
 * Survives a reload, which a carpooling app on a flaky connection needs.
 * Storage may be unavailable (private mode, blocked site data), so every access
 * is guarded and simply degrades to "signed out" rather than throwing.
 */
export function createWebTokenStore(storageKey) {
    const safeStorage = () => {
        try {
            return typeof window === 'undefined' ? null : window.localStorage;
        }
        catch {
            return null;
        }
    };
    return {
        read() {
            try {
                const raw = safeStorage()?.getItem(storageKey);
                return raw ? JSON.parse(raw) : null;
            }
            catch {
                return null;
            }
        },
        write(tokens) {
            try {
                safeStorage()?.setItem(storageKey, JSON.stringify(tokens));
            }
            catch {
                /* storage unavailable — the session stays in memory for this tab */
            }
        },
        clear() {
            try {
                safeStorage()?.removeItem(storageKey);
            }
            catch {
                /* nothing to do */
            }
        },
    };
}
//# sourceMappingURL=tokens.js.map